import * as z from 'zod';

import { companyQueryLinkerSchema } from './company-query-linker-schema';

import { paginatedResponseSchema } from '../generic';
import { phoneNumberQuerySchema } from '../phone-numbers';

export const companyLinkerWithPhoneNumbersQuerySchema = companyQueryLinkerSchema.extend({
  phone_numbers: z.array(phoneNumberQuerySchema).nullable(),
});

export type CompanyLinkerWithPhoneNumbersQuerySchema = z.infer<typeof companyLinkerWithPhoneNumbersQuerySchema>;

export const companyLinkerWithPhoneNumbersQueryAllSchema = paginatedResponseSchema(
  companyLinkerWithPhoneNumbersQuerySchema
);

export type CompanyLinkerWithPhoneNumbersQueryAllSchema = z.infer<typeof companyLinkerWithPhoneNumbersQueryAllSchema>;
